/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { DateTimeTypes } from '@gh/common-shared';
import { TypeService } from '@gh/core-type';
import { buildDateTimeColumn, LayoutBasedGridDefinition } from '@gh/core-ui-grid';
import { ColDef, GridOptions } from 'ag-grid-community';
import { Ael } from '../../resources/ael.model';

@Injectable()
export class AelGridDefinition extends LayoutBasedGridDefinition {
  constructor(private typeService: TypeService) {
    super();
  }

  buildGridOptions(): GridOptions {
    return { getRowNodeId: (data: Ael) => data.eventId };
  }

  buildColumnDefs(): Hash<ColDef> {
    return {
      eventDate: buildDateTimeColumn(DateTimeTypes.Timestamp),
    };
  }
}
